import PropTypes from 'prop-types'
import { Link } from 'react-router'
import { useSelector } from 'react-redux'

import SidebarButton from './bones/SidebarButton'
import getIcon from './helpers/getIcon'
import getSelection from './helpers/getSelection'
import getAdminAuthorization from './helpers/getAdminAuthorization'
import moduleIsActive from './helpers/moduleIsActive'
import SidebarRouterButton from './bones/SidebarRouterButton'
import { useTranslation } from 'react-i18next'
import useBusinessType from '@/shared/hooks/useBusinessType'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { StyledDivider, SIZE } from 'baseui/divider'
import SidebarMenuBrand from './bones/SidebarMenuBrand'
import useSidebarLogout from './useSidebarLogout'
import { VERTICAL_ICON_KEYS } from './redesignedMenu'

const SidebarMenu = ({ isAdmin, isSelectraAdmin, error, applicationType = 'energie' }) => {
  const { t } = useTranslation()
  const onLogout = useSidebarLogout()
  const {
    loaderRoutesEnergy,
    loaderRoutes,
    loaderRoutesInsurance,
    modulesStatuses,
    modulesStatusesEnergy,
    modulesStatusesInsurance,
    country,
    isExternal,
    commonData,
  } = useSelector(selectAuthData)
  const { getApplicationMenuRoutes, getModulesStatuses, availableVerticals } = useBusinessType({
    loaderRoutesEnergy,
    loaderRoutesInsurance,
    loaderRoutes,
    modulesStatuses,
    modulesStatusesEnergy,
    modulesStatusesInsurance,
  })
  const routes = getApplicationMenuRoutes(applicationType)
  const modulesStatus = getModulesStatuses(applicationType)
  const links = []
  Object.keys(routes).forEach(key => {
    const isSelected = getSelection(routes[key])
    const icon = getIcon(key)
    const translation = t('menu:' + key)

    if (
      moduleIsActive(key, modulesStatus, country, isExternal, commonData) &&
      getAdminAuthorization(isAdmin, isSelectraAdmin, key)
    ) {
      if (error === true && key !== 'logout') return
      if (key !== 'logout') {
        links.push(
          <Link key={'menu-link-' + key} to={routes[key]} id={key} aria-label={translation}>
            <SidebarRouterButton key={key} isSelected={isSelected} text={translation} icon={icon} />
          </Link>,
        )
      } else {
        links.push(
          <SidebarButton
            key={key}
            isSelected={getSelection(routes[key])}
            text={t('menu:' + key)}
            url={'#'}
            icon={getIcon(key)}
            clickHandler={onLogout}
          />,
        )
      }
    }
  })

  return (
    <>
      <SidebarMenuBrand country={country} />
      {links}
      <div
        style={{
          width: '40px',
          borderRadius: '8px',
          alignSelf: 'center',
          flexShrink: 0,
        }}
      >
        <StyledDivider $size={SIZE.section} />
      </div>
      {isAdmin &&
        availableVerticals
          .filter(vertical => vertical !== applicationType)
          .map(vertical => {
            const label = t(`menu:goTo.${vertical}`)

            return (
              <Link key={`menu-link-go-to-${vertical}`} to={`/${vertical}`} id={`to-${vertical}`} aria-label={label}>
                <SidebarRouterButton
                  key={`button-to-${vertical}`}
                  text={label}
                  icon={getIcon(VERTICAL_ICON_KEYS[vertical])}
                />
              </Link>
            )
          })}
    </>
  )
}

SidebarMenu.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  isSelectraAdmin: PropTypes.bool.isRequired,
  applicationType: PropTypes.string,
  error: PropTypes.bool,
}

export default SidebarMenu
